import { CenteredContainer } from 'common-front/src/components/centeredContainer/centeredContainer';
import { Form } from 'common-front/src/components/form/form';
import { FullScreenPopup } from 'common-front/src/components/fullScreenPopup/fullScreenPopup';
import { Button } from 'common-front/src/designSystem/components/button';
import { EmptyFormBox } from 'common-front/src/designSystem/components/formBox';
import { Skeleton } from 'common/src/designSystem/components/skeleton';
import { RoleInputService } from 'common/src/input/roleInput';
import {
    useHistory,
    useParams,
    useService,
    useTranslate
} from 'common/src/util/dependencies/dependencies';
import { HeaventPaths } from 'common/src/util/paths/heaventPaths';
import * as React from 'react';
import { useRoleQuery, useRoleUpdateMutation } from '../../../generated/graphqlHooks';
import { useNotificationContext } from '../../../notifications/notificationContext';
import { isEditable } from '../isEditable';
import { RoleForm, RoleFormSkeleton } from './roleForm';

export const RoleUpdate = () => {
    const { organizationId, roleId } = useParams();
    const translate = useTranslate();
    const centeredContainerRef = React.useRef<HTMLDivElement | null>(null);
    const inputService = useService(RoleInputService);
    const { mutate } = useRoleUpdateMutation();
    const history = useHistory();
    const { data, isLoading } = useRoleQuery({ organizationId, roleId });
    const { showNotification } = useNotificationContext();

    return isLoading ? (
        <RoleUpdateSkeleton />
    ) : (
        <Form
            height={1}
            hideErrors={true}
            initialValues={(({ positionPermissions, name, description }) => ({
                role: {
                    positionPermissions,
                    name,
                    description
                }
            }))(data.organization.role)}
            render={({ handleSubmit, submitting }) => (
                <FullScreenPopup
                    button={
                        isEditable(data.organization.role) ? (
                            <Button
                                css={{ flexShrink: 0 }}
                                isLoading={submitting}
                                onClick={handleSubmit}
                            >
                                {translate('modifier_le_r_l_58957')}
                            </Button>
                        ) : undefined
                    }
                    category={
                        isEditable(data.organization.role)
                            ? translate('modification_du_29490')
                            : translate('r_le_pr_d_fini_14582')
                    }
                    color="dark"
                    fallbackClosePath={HeaventPaths.ORGANIZATION_PARAMETERS_ROLES(organizationId)}
                    title={data.organization.role.name}
                >
                    <CenteredContainer ref={centeredContainerRef}>
                        <RoleForm disabled={!isEditable(data.organization.role)}>
                            {isEditable(data.organization.role) && (
                                <EmptyFormBox>
                                    <Button
                                        isLoading={submitting}
                                        textAlign="center"
                                        onClick={handleSubmit}
                                    >
                                        {translate('modifier_le_r_l_58957')}
                                    </Button>
                                </EmptyFormBox>
                            )}
                        </RoleForm>
                    </CenteredContainer>
                </FullScreenPopup>
            )}
            schema={inputService.schema()}
            onShowErrors={() => {
                if (centeredContainerRef.current) {
                    centeredContainerRef.current.scrollTop = 0;
                }
            }}
            onSubmit={async ({ role }) => {
                if (isEditable(data.organization.role)) {
                    await mutate({ organizationId, roleId, role });
                    showNotification({
                        color: 'success',
                        icon: 'circle-info',
                        text: translate('le_r_le_a_bien_48312')
                    });
                    history.goBack(HeaventPaths.ORGANIZATION_PARAMETERS_ROLES(organizationId));
                }
            }}
        />
    );
};

const RoleUpdateSkeleton = () => {
    const { organizationId } = useParams();

    return (
        <FullScreenPopup
            fallbackClosePath={HeaventPaths.ORGANIZATION_PARAMETERS_ROLES(organizationId)}
            title={<Skeleton borderRadius="$1" height={39} width={400} />}
        >
            <CenteredContainer>
                <RoleFormSkeleton />
            </CenteredContainer>
        </FullScreenPopup>
    );
};
